import { Combobox, InputField } from "../../../components";
import { BusinessInformationFormFields } from "./service";
import {
  FormikErrors,
  FormikHandlers,
  FormikTouched,
  FormikHelpers,
} from "formik";

type LoanPurposeOption = { value: string; label: string };
type LoanPurposeGroup = { label: string; options: LoanPurposeOption[] };
type LoanPurposeHeadingOption = LoanPurposeOption & {
  isHeadingOption?: boolean;
};
type LoanPurposeOptions = Array<LoanPurposeGroup | LoanPurposeHeadingOption>;

interface LoanReasonFormProps {
  values: BusinessInformationFormFields;
  errors: FormikErrors<BusinessInformationFormFields>;
  touched: FormikTouched<BusinessInformationFormFields>;
  handleBlur: FormikHandlers["handleBlur"];
  handleChange: FormikHandlers["handleChange"];
  setFieldValue: FormikHelpers<BusinessInformationFormFields>["setFieldValue"];
  setFieldTouched: FormikHelpers<BusinessInformationFormFields>["setFieldTouched"];
  setFieldError: FormikHelpers<BusinessInformationFormFields>["setFieldError"];
  loanPurposeReasons: LoanPurposeOptions;
}

export const LoanReasonForm: React.FC<LoanReasonFormProps> = ({
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  loanPurposeReasons,
}) => {
  const selectedLoanPurpose =
    loanPurposeReasons
      .flatMap((item) => ("options" in item ? item.options : [item]))
      .find((e) => e.value === values.loanPurpose) ?? undefined;

  return (
    <>
      <div className="cx-font-semibold cx-text-text-primary cx-text-base cx-mb-4">
        Intended use of funds
      </div>
      <div className="cx-flex cx-justify-between md:cx-mb-4 max-md:cx-flex-col">
        <div className="cx-w-full max-md:cx-mb-4">
          <Combobox
            placeholder="Select reason"
            showEllipsis={false}
            options={loanPurposeReasons}
            inputProps={{
              name: "loanPurpose",
              value: selectedLoanPurpose,
            }}
            onChange={(val) => {
              const value = val ?? "";
              setFieldValue("loanPurpose", value, false);
              setFieldTouched("loanPurpose", true, false);
              if (value) {
                setFieldError("loanPurpose", undefined);
              }
              if (val !== "OTHERS") {
                setFieldValue("loanPurposeDescription", "", false);
              }
            }}
            error={
              touched.loanPurpose && !!errors.loanPurpose
                ? errors.loanPurpose
                : ""
            }
          />
        </div>
      </div>
      {values.loanPurpose === "OTHERS" && (
        <div className="cx-mb-4">
          <InputField
            label="Describe purpose"
            tick={
              touched.loanPurposeDescription && !errors.loanPurposeDescription
            }
            error={
              touched.loanPurposeDescription && !!errors.loanPurposeDescription
                ? errors.loanPurposeDescription
                : ""
            }
            inputProps={{
              name: "loanPurposeDescription",
              value: values.loanPurposeDescription,
              onChange: handleChange,
              onBlur: handleBlur,
              maxLength: 200,
            }}
          />
        </div>
      )}
    </>
  );
};
